// ** React Imports
import { ReactNode, ReactElement, useEffect } from 'react'

// ** Next Import
import { useRouter } from 'next/router'

// ** Hooks Import
import { useAuth } from 'src/hooks/useAuth'
import { useSelector } from 'react-redux'
import { RootState } from 'src/redux/store'

interface GuestGuardProps {
  children: ReactNode
  fallback: ReactElement | null
}

const GuestGuard = (props: GuestGuardProps) => {
  const { children, fallback } = props
  const auth = useAuth()
  const router = useRouter()
  const userData = useSelector((state:RootState)=> state.user.userProfileData)

  useEffect(() => {
    if (!router.isReady) {
      return
    }
    console.log("userData",userData);
    if (window.localStorage.getItem('userData')) {
      router.replace('/dashboards/analytics/')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [router.route])

  if (auth.loading || (!auth.loading && auth.user !== null)) {
    return fallback
  }

  return <>{children}</>
}

export default GuestGuard
